import { NavLink } from "react-router-dom";
import { Tv, Film, Clapperboard, CalendarClock, Heart, History, Settings2 } from "lucide-react";

const NAV = [
  ["/live", "Live TV", Tv],
  ["/movies", "Movies", Film],
  ["/series", "Series", Clapperboard],
  ["/guide", "TV Guide", CalendarClock],
  ["/favorites", "Favourites", Heart],
  ["/recent", "Recently watched", History],
];

export default function Sidebar({ onManage }) {
  return (
    <nav className="w-[72px] lg:w-[220px] shrink-0 border-r border-[#212738] bg-[#0B0D14] flex flex-col py-4 gap-1" data-testid="sidebar">
      {NAV.map(([to, label, Icon]) => (
        <NavLink
          key={to}
          to={to}
          data-testid={`nav-${to.slice(1)}`}
          className={({ isActive }) =>
            `group relative mx-3 flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm transition-colors duration-200 ${
              isActive ? "bg-[#1A1E2E] text-white" : "text-slate-400 hover:text-white hover:bg-[#11141F]"
            }`
          }
        >
          {({ isActive }) => (
            <>
              {isActive && <span className="absolute -left-3 top-2 bottom-2 w-[3px] rounded-r bg-[#E50914]" />}
              <Icon className={`w-5 h-5 shrink-0 ${isActive ? "text-[#E50914]" : ""}`} />
              <span className="hidden lg:inline">{label}</span>
            </>
          )}
        </NavLink>
      ))}
      <div className="flex-1" />
      <button
        onClick={onManage}
        className="mx-3 flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm text-slate-400 hover:text-white hover:bg-[#11141F] transition-colors"
        data-testid="nav-playlists"
      >
        <Settings2 className="w-5 h-5" />
        <span className="hidden lg:inline">Playlists</span>
      </button>
    </nav>
  );
}
